import { transactionIdSetter } from "helpers/transactionIdFilter";
import React from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";
import { useAppSelector } from "store";

interface Props {
  operationId: string;
  setOperationId: (value: string) => void;

  userId: string;
  setUserId: (value: string) => void;

  selectedCurrencies: { value: string | number; label: string }[];
  handleUpdateCurrencies: (
    e: { value: string | number; label: string }[],
  ) => void;

  selectedReasons: { value: string | number; label: string }[];
  handleUpdateReasons: (e: { value: string | number; label: string }[]) => void;

  selectedTypes: { value: string | number; label: string }[];
  handleUpdateTypes: (e: { value: string | number; label: string }[]) => void;

  selectedStatuses: { value: string | number; label: string }[];
  handleUpdateStatuses: (
    e: { value: string | number; label: string }[],
  ) => void;

  handleApply: () => void;
}

const OperationsFilters: React.FC<Props> = ({
  operationId,
  setOperationId,
  userId,
  setUserId,
  selectedCurrencies,
  handleUpdateCurrencies,
  selectedReasons,
  handleUpdateReasons,
  selectedTypes,
  handleUpdateTypes,
  selectedStatuses,
  handleUpdateStatuses,
  handleApply,
}) => {

  const operationTypes = [
    { value: "game", label: "game" },
    { value: "deposit", label: "deposit" },
    { value: "accrual", label: "accrual" },
  ];

  const reasonCodes = [
    { value: "GAME_BET", label: "GAME_BET" },
    { value: "GAME_WIN", label: "GAME_WIN" },
    { value: "GAME_REFUND", label: "GAME_REFUND" },
    { value: "GAME_ROLLBACK", label: "GAME_ROLLBACK" },
    { value: "BONUS_GRANT", label: "BONUS_GRANT" },
  ];

  const statusCodes = [
    { value: "completed", label: "completed" },
    { value: "declined", label: "declined" },
  ];

  const currenciesList = useAppSelector((store) => store.settings.currencies);

  const currencies =
    currenciesList?.map((el) => ({
      value: el,
      label: el,
    })) ?? [];

  const handleClearFilters = () => {
    setOperationId("");
    setUserId("");
    handleUpdateCurrencies([]);
    handleUpdateReasons([]);
    handleUpdateTypes([]);
    handleUpdateStatuses([]);
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: "Operation ID",
          boxTitle: "Operation ID",
          icon: gridIcon,
          inputValue: operationId,
          setInputValue: transactionIdSetter(setOperationId, true),
        },
        {
          type: FilterItemTypes.input,
          title: "User ID",
          boxTitle: "User ID",
          icon: gridIcon,
          inputValue: userId,
          setInputValue: transactionIdSetter(setUserId, true),
        },
        {
          type: FilterItemTypes.multiselect,
          title: "Currencies",
          boxTitle: "Currencies",
          icon: gridIcon,
          itemsArray: currencies,
          activeItems: selectedCurrencies,
          handleApply: handleUpdateCurrencies,
        },
        {
          type: FilterItemTypes.multiselect,
          title: "Types",
          boxTitle: "Types",
          icon: gridIcon,
          itemsArray: operationTypes,
          activeItems: selectedTypes,
          handleApply: handleUpdateTypes,
        },
        {
          type: FilterItemTypes.multiselect,
          title: "Reasons",
          boxTitle: "Reasons",
          icon: gridIcon,
          itemsArray: reasonCodes,
          activeItems: selectedReasons,
          handleApply: handleUpdateReasons,
        },
        {
          type: FilterItemTypes.multiselect,
          title: "Statuses",
          boxTitle: "Statuses",
          icon: gridIcon,
          itemsArray: statusCodes,
          activeItems: selectedStatuses,
          handleApply: handleUpdateStatuses,
        },
      ]}
    />
  );
};

export default OperationsFilters;
